import bowser from 'bowser';

export const browserDetails = bowser.parse(window.navigator.userAgent);
